export const baseQuestion = {
  enabled: true,
  optional: false,
  conditionalMode: null,
  conditionalCategory: null,
  conditionalValue: null,
  conditionalQuestionId: null,
  configuration: {},
  category: null,
  referenceKey: null
};
export enum COMPONENT_TYPES {
  Component = 'component',
  Module = 'module',
}